var MS_WORD_REGEX = /^<html[^>]*xmlns:w="urn:schemas-microsoft-com:office:word"/;
export default function isPasteFromMSWord(transfer) {
  return transfer.html && transfer.html.length && MS_WORD_REGEX.test(transfer.html);
}